import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, data, isLoading, exec } = useRequest({
    url: '/api/device/efficiency',
    name: 'deviceEfficiencyGet',
    method: 'GET'
  });
  return [isRequestSuccessed, data || [], exec, isLoading];
});
